<template>
    <div class="page-container">
        <Navigation position="top"/>
        <md-app>
            <md-app-content class="md-scrollbar">
                <div class="md-layout">
                    <div class="md-layout-item md-size-25 md-xsmall-hide">
                        <div>
                            <img src="./assets/passfoto_falk-huth_200x200.png" alt="Falk Huth" />
                        </div>
                        <Navigation position="left"/>
                    </div>
                    <div class="md-layout-item md-size-75 md-xsmall-size-100">
                        <router-view></router-view>
                    </div>
                </div>
                <div class="md-layout zeile-unten">
                    <div class="md-layout-item md-size-100">
                        <Navigation position="bottom"/>
                    </div>
                </div>
            </md-app-content>
        </md-app>
    </div>
</template>

<script>
    // Vue core components
    import Vue from 'vue'
    import VueRouter from 'vue-router'

    // configuration
    Vue.config.productionTip = false

    // VueMaterial
    import VueMaterial from 'vue-material'
    import 'vue-material/dist/vue-material.min.css'
    import 'vue-material/dist/theme/default.css'

    // Own components
    import Navigation from './components/common/Navigation'

    export default {
        name: 'app',
        components: {
            Navigation
        },
        data: () => ({
            menuVisible: false,
            calendarVisible: false,
            selectedPage: "Home"
        })
    }

    Vue.use(VueRouter)
    Vue.use(VueMaterial)
</script>

<style lang="scss" scoped>
    .page-container {
        position: absolute;
        top: 0;
        left: 0;
        min-height: 100%;
        max-height: 100%;
        min-width: 100%;
        max-width: 100%;
        overflow: hidden;
        display: flex;
        flex-direction: column;
    }
    .md-app {
        border: 1px solid rgba(#000, .12);
    }
    .md-app-content {
        overflow-y: auto;
    }
    .zeile-unten {
        margin-top: 20px;
    }
    .scrollbereich {
        overflow-y: auto;
        border: 1px solid rgba(#000, .12);
    }
</style>
